import { Reducer } from "@reduxjs/toolkit";
import { EstadoRequisicao } from "store/types";
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils";
import { AriaSort } from "view/component/Tabela/model/OrdemColunaTabela";
import { SolicitacoesAction } from "./Solicitacoes.action";
import { SolicitacoesActionTypes, SolicitacoesState } from "./Solicitacoes.types";


const estadoInicial: SolicitacoesState = {
    estado: EstadoRequisicao.OCIOSO,
    erros: undefined,
    elementos: [],
    totalElementos: 0,
    filtros: {},
    ordem: {ordem: AriaSort.Descending, coluna: "dataCriacao"},
    pagina: {
        atual: 1,
        total: 1,
    },
}

export const solicitacoesReducer: Reducer<SolicitacoesState, SolicitacoesActionTypes> = (state = estadoInicial, action): SolicitacoesState => {
    if (SolicitacoesAction.lista._carregar.pending.match(action)){
        const {acao, queryParams: queryParamsSolicitados, ordem: novaOrdem, preservarOrdem } = action.meta.arg;

        const paginaAtual = acao === 'novaBusca'
            ? 0
            : state.pagina.atual;
       
        const totalPaginas = acao === 'novaBusca'
            ? 1 
            : state.pagina.total;

        const filtros = acao === 'novaBusca'
            ? queryParamsSolicitados
            : state.filtros;

        const ordem = novaOrdem !== undefined || (novaOrdem === undefined && !preservarOrdem)
            ? novaOrdem
            : state.ordem;
        return {
            ...state,
            estado: EstadoRequisicao.CARREGANDO,
            erros: undefined,
            elementos: state.elementos,
            filtros: filtros ?? {},
            ordem: ordem,
            pagina: {
                atual: paginaAtual,
                total: totalPaginas
            },
        }
    } else if (SolicitacoesAction.lista._carregar.fulfilled.match(action)){
        return {
            ...state,
            estado: EstadoRequisicao.BEM_SUCEDIDO,
            elementos: action.payload.content,
            totalElementos: action.payload.totalElements,

            pagina: {
                atual: action.payload.pageable.pageNumber,
                total: action.payload.totalPages
            },
        }
    } else if (SolicitacoesAction.lista._carregar.rejected.match(action)){
        return {
            ...state,
            estado: EstadoRequisicao.FALHOU,
            erros: action.payload as ResponseError,
            elementos: []
        }
    } 
    return state;
}